import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	Inject,
	Type,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialog
} from '@angular/material/dialog';
import { ValidityFormService } from '../services/validity-form.service';
import { SharedDataFormService } from '../services/shared-data.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseResponsiveState } from 'src/app/shared/classes/responsive-state';
import { BreakpointService, PopupService } from 'src/app/shared/services';

@Component({
	selector: 'app-base-popup',
	templateUrl: './base-popup.component.html',
	styleUrls: ['./base-popup.component.scss']
})
export class BasePopupComponent
	extends BaseResponsiveState
	implements AfterViewInit
{
	@ViewChild('container', { read: ViewContainerRef })
	containerRef: ViewContainerRef;
	/** This is the list of components inside the generic popup.
	 *  They will be returned on close.
	 */
	children: any[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: BasePopupData,
		private mdDialogRef: MatDialogRef<BasePopupComponent>,
		private cdref: ChangeDetectorRef,
		public validityFormService: ValidityFormService,
		private dialog: MatDialog,
		private sharedDataService: SharedDataFormService,
		private alertService: AlertService,
		public override breakpointService: BreakpointService,
		private popupService: PopupService
	) {
		super(breakpointService);
		this.setResponsiveState();
	}

	ngAfterViewInit() {
		this.renderChildComponents();
		this.cdref.detectChanges();
	}

	private renderChildComponents(): void {
		this.containerRef.clear();
		/** In case there is a component map and it has at least one component... */
		if (this.data.componentMap && this.data.componentMap.length > 0) {
			for (const component of this.data.componentMap) {
				/** Create the component based on the component name reference */
				const componentRef = this.containerRef.createComponent(component.name);
				/** and bind the data it needs internally to work */
				componentRef.instance.data = { ...component.data };
				this.children.push(componentRef.instance);
			}
		} else {
			/** In case the base popup doesn't have a component map (and therefore a form),
			 * it sets the validity to true so that the accept button is enabled */
			this.validityFormService.setValidity(true);
		}
	}

	public close(value?: any) {
		this.mdDialogRef.close(value);
	}

	public cancel() {
		this.close(false);
	}

	public confirm() {
		if (this.data.checkConfirmationVariable === undefined) {
			this.data.checkConfirmationVariable = false;
		}
		if (this.data.saveData === undefined) {
			this.data.saveData = false;
		}
		if (this.data.checkConfirmationVariable) {
			const confirmationData: BasePopupData = {
				subtitle: '¿Desea confirmar la Deshabilitación de la empresa?',
				buttonCancelText: 'Cancelar',
				buttonConfirmText: 'Confirmar'
			};
			this.dialog
				.open(BasePopupComponent, {
					width: this.popupService.messagePopupWidth,
					data: confirmationData
				})
				.afterClosed()
				.subscribe((result: any) => {
					if (result) {
						this.close(this.children);
					}
				});
		} else if (
			this.data.checkConfirmationVariable == false &&
			!this.data.saveData
		) {
			this.close(this.children);
		}
		if (this.data.saveData) {
			const result = this.sharedDataService.setBranchData(this.children[0]);
			if (result) {
				this.close(this.children);
			} else {
				this.alertService.open(
					this.alertService.datosError.errorMessage,
					'Aceptar'
				);
			}
		}
	}
}

export interface BasePopupData {
	buttonCancelText: string;
	buttonConfirmText?: string;
	componentMap?: ComponentMap[];
	title?: string;
	subtitle?: string;
	popupFormulario?: boolean;
	checkConfirmationVariable?: boolean;
	saveData?: boolean;
	isDragable?: boolean;
}

export type ComponentMap = {
	name: Type<any>;
	data: any;
};
